import { Banner } from '@aloft/toolkit-sui';
import { useQuery } from '@tanstack/react-query';

import { useToolkitContext } from '../hooks/api/toolkitContext.ts';
import { toolkitFetch } from '../hooks/api/toolkitFetcher.ts';

export const ServerDownBanner = () => {
  const { fetcherOptions } = useToolkitContext();
  const pingRes = useQuery({
    queryKey: ['ping'],
    queryFn: () => toolkitFetch({ url: '/ping', method: 'GET', ...fetcherOptions }),
    refetchInterval: 1_000 * 5,
    staleTime: 0,
    retry: true,
    retryDelay: 2_000,
  });

  const serverNotLookingTooGood = pingRes.failureCount > 2;

  return (
    serverNotLookingTooGood && (
      <Banner
        status="error"
        title="We're not able to contact the server."
        canDismiss={false}
        description="It may not be responding, or your Internet connection may have been interrupted. You can try refreshing the page but we cannot guarantee your changes will be saved."
      />
    )
  );
};
